import { render, staticRenderFns } from "./bonusRules.vue?vue&type=template&id=5a60908a&scoped=true"
import script from "./bonusRules.vue?vue&type=script&lang=js"
export * from "./bonusRules.vue?vue&type=script&lang=js"
import style0 from "./bonusRules.vue?vue&type=style&index=0&id=5a60908a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a60908a",
  null
  
)

export default component.exports